const DIP_COMMON_PEOPLE = [
  'richard.deloughy@dealerimagepro.com',
  'richard@dealerimagepro.com',
  'peter@dealerimagepro.com',
  'chris.thomas@dealerimagepro.com'
];

export const DEVELOPERS_ACCESS = [
  'ankita.bhadeshiya@eryushion.com',
  'eryushion.techsol@gmail.com',
  'ravi.rathod@eryushion.com',
  'kashmeera.kadachhi@eryushion.com',
  'vimal14569@gmail.com',
  'vimal.ghorecha@dealerimagepro.com',
  'hiren.bhindi@eryushion.com',
  'aniruddh.purohit@dealerimagepro.com',
  'uday.odedara@eryushion.com'
];

export const VIDEO_GENERATION_PAGE_ACCESS_FOR_USER = [
  'westerliestrade@gmail.com',
  'eduardo.ramirez@dealerimagepro.com',
  'yuchen.huang@dealerimagepro.com',
  ...DIP_COMMON_PEOPLE,
  ...DEVELOPERS_ACCESS
];

export const SERVICE_INDICATOR_DATE_RANGE_SELECTOR_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'rafael@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

export const DEALERSHIP_USAGE_DOWNLOAD_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  'jason.eisenberg@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

export const REPOCESS_ALL_VIDEO_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'eduardo.ramirez@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  'cameron@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

export const UPLOAD_ACTION_ACCESS = [
  'ankita.bhadeshiya@eryushion.com',
  'ravi.rathod@eryushion.com',
  'kashmeera.kadachhi@eryushion.com',
  'hiren.bhindi@eryushion.com',
  'aniruddh.purohit@dealerimagepro.com',
  'uday.odedara@eryushion.com'
];
